module.exports = __webpack_public_path__ + "static/media/admin.09113287.png";